const accountServiceBaseUrl = process.env.REACT_APP_ACCOUNT_SERVICE_URL;

export const API_ENDPOINTS = {
    USERS: {
        LOGIN: `${accountServiceBaseUrl}/account/auth/login`,
        AUTH_DATA: `${accountServiceBaseUrl}/account/user/auth-data`,
    },
};
